<script>
import {Pie, mixins} from 'vue-chartjs'

const {reactiveProp} = mixins;

export default {
    name: 'pie-chart',
    extends: Pie,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            options: {
                legend: {
                    display: true
                },
                animation: false,
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        update() {
            this.$data._chart.update();
        }
    }
}
</script>
